import React from "react";
import classNames from "classnames";

const LiveCounter = ({ current, total, label = "잔여 수량" }) => {
  const percentage = total > 0 ? (current / total) * 100 : 0;
  const isLow = percentage <= 20;
  const isSoldOut = current === 0;

  const counterClasses = classNames("newyear-live-counter", {
    "newyear-live-counter--low": isLow && !isSoldOut,
    "newyear-live-counter--soldout": isSoldOut,
  });

  return (
    <div className={counterClasses}>
      <span className="newyear-live-counter__label">{label}</span>
      <div className="newyear-live-counter__display">
        <span className="newyear-live-counter__current">{current}</span>
        <span className="newyear-live-counter__separator">/</span>
        <span className="newyear-live-counter__total">{total}</span>
      </div>
      <div className="newyear-live-counter__progress">
        <div
          className="newyear-live-counter__progress-bar"
          style={{ width: `${percentage}%` }}
        />
      </div>
      {isSoldOut && <span className="newyear-live-counter__status">마감</span>}
    </div>
  );
};

export default LiveCounter;
